import React from 'react';

const MMA = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 14 14'
            className={className}
        >
            <g id='MMA' transform='translate(-54.328 -330.011)'>
                <path
                    id='Path_3109'
                    data-name='Path 3109'
                    d='M56.112,342.247q-.765-.712-1.53-1.426c-.342-.321-.338-.564,0-.883l2.515-2.363a1.815,1.815,0,0,0,.545-1.006q.448-2.289.9-4.577a.829.829,0,0,1,.784-.742l3.584-.676a.739.739,0,0,1,.915.421c.517.991,1.037,1.98,1.546,2.974a2.147,2.147,0,0,1,.179.545.554.554,0,0,1-.231.569,1.351,1.351,0,0,1-.89.3.827.827,0,0,1-.707-.428c-.292-.5-.573-1.014-.812-1.54s-.712-.518-1.142-.288a.439.439,0,0,0-.163.57c.134.355.278.707.415,1.062a1.455,1.455,0,0,1-.043,1.239c-.389.775-.76,1.56-1.136,2.34a.794.794,0,0,0-.055.12.251.251,0,0,0,.467.182c.123-.223.24-.449.359-.674q.326-.616.653-1.232a.614.614,0,0,1,.095-.155c.049-.049.124-.117.175-.11s.126.082.174.137a.41.41,0,0,1,.055.138l.627,1.91a.777.777,0,0,0,.839.583c.347,0,.692,0,1.037.009a.989.989,0,0,1,.291.107.794.794,0,0,1-.131.252,6.659,6.659,0,0,1-3.445,1.582,1.092,1.092,0,0,1-.175.009,1.324,1.324,0,0,0-.931.362q-1.145,1.068-2.289,2.133a.582.582,0,0,1-.933,0Q56.882,342.969,56.112,342.247Z'
                    transform='translate(0 0.09)'
                />
                <path
                    id='Path_3110'
                    data-name='Path 3110'
                    d='M62.414,336.273a.632.632,0,0,1,.008-.982.805.805,0,0,1,.26-.092q1.617-.308,3.238-.607c.4-.073.618.086.652.463.019.2.037.392.046.589a.523.523,0,0,1-.526.564c-1.05.086-2.1.166-3.152.247A.661.661,0,0,1,62.414,336.273Z'
                    transform='translate(1.31 0.761)'
                />
                <path
                    id='Path_3111'
                    data-name='Path 3111'
                    d='M63.672,332.2a2.352,2.352,0,0,1-.125-.212q-.25-.53-.494-1.064c-.149-.329-.028-.543.349-.611q.809-.147,1.621-.286a.56.56,0,0,1,.713.438q.151.581.292,1.162a.459.459,0,0,1-.433.6c-.421.066-.844.125-1.266.187A.8.8,0,0,1,63.672,332.2Z'
                    transform='translate(1.444)'
                />
                <path
                    id='Path_3112'
                    data-name='Path 3112'
                    d='M62.729,337.654a.641.641,0,0,1-.21-.688.539.539,0,0,1,.495-.361c.907-.1,1.813-.208,2.72-.307.368-.04.565.137.552.484-.008.229-.016.459-.032.687a.493.493,0,0,1-.588.487c-.853-.059-1.706-.119-2.556-.19A1.648,1.648,0,0,1,62.729,337.654Z'
                    transform='translate(1.36 1.047)'
                />
                <path
                    id='Path_3113'
                    data-name='Path 3113'
                    d='M64.645,334.3a1.8,1.8,0,0,1-.12-.191c-.156-.316-.312-.634-.462-.952-.138-.293-.03-.472.309-.526q.693-.109,1.386-.212a.525.525,0,0,1,.653.4q.144.506.279,1.014c.084.316-.046.495-.39.539s-.7.085-1.044.131A.743.743,0,0,1,64.645,334.3Z'
                    transform='translate(1.613 0.4)'
                />
            </g>
        </svg>
    );
};

export default MMA;
